import React, { FC, useRef } from 'react';
import { Dialog } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import API from 'api/API';
import Button from 'components/Button';
import InputField from 'components/InputField';
import { SetModalButtonContainer, SetModalHeader, SetModalMedium } from 'components/SetModal/SetModal.styles';
import { useLanguage } from 'context/AppContext';

interface CreateModalProps {
  open: boolean;
  close: () => void;
}

const CreateDeviceModal: FC<CreateModalProps> = ({ open, close }) => {
  const deviceName = useRef('');
  const navigate = useNavigate();
  const [language] = useLanguage();

  const handleCreate = async (): Promise<void> => {
    try {
      await API.device.get(deviceName.current);
      close();
      navigate(`/device/${deviceName.current}/edit`);
    } catch (error) {
      API.errorHandler(error);
    }
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="md">
      <SetModalMedium>
        <SetModalHeader>{language.CreateModal.deviceCodeTitle}</SetModalHeader>
        <InputField
          variant="outlined"
          fullWidth
          placeholder={language.CreateModal.deviceCodePlaceholder}
          onChange={e => (deviceName.current = e.target.value)}
        />
        <SetModalButtonContainer>
          <Button fullWidth onClick={handleCreate}>
            {language.CreateModal.add}
          </Button>
        </SetModalButtonContainer>
      </SetModalMedium>
    </Dialog>
  );
};

export default CreateDeviceModal;
